let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fEnfV")).then(() => parcelRequire('4Cs4A'));